import { cn } from '../../../lib/styles';
import type { FormActionsProps, FormGap, FormProps } from './types';

const GAP_MAP: Record<FormGap, string> = {
  sm: 'gap-2',
  md: 'gap-4',
};

export function FormBase({ children, onSubmit, onReset, gap = 'md' }: FormProps) {
  return (
    <form
      className={cn('flex flex-col', GAP_MAP[gap])}
      onSubmit={async (e) => {
        e.preventDefault();
        e.stopPropagation();

        await onSubmit?.();
      }}
      onReset={async (e) => {
        e.preventDefault();
        e.stopPropagation();

        await onReset?.();
      }}
    >
      {children}
    </form>
  );
}

export function FormActions({ children }: FormActionsProps) {
  return <div className="flex justify-end gap-2">{children}</div>;
}
